<template>
  <div>
    <vs-popup
      class="holamundo"
      title="Mutfak Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Mutfağı Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteKitchen(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-button
      @click="openAddModal"
      color="primary"
      type="filled"
      style="margin-top: 20px"
      >Yeni Mutfak Ekle</vs-button
    >
    <vs-table search :data="kitchens">
      <template slot="header">
        <h3>Şube Mutfakları</h3>
      </template>
      <template slot="thead">
        <vs-th sort-key="name"> Mutfak Adı </vs-th>
        <vs-th> İşlemler </vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td :data="data[indextr].name">
            {{ data[indextr].name }}
          </vs-td>
          <vs-td>
            <feather-icon
              icon="EditIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click.stop="editKitchen(tr)"
            />
            <feather-icon
              icon="TrashIcon"
              svgClasses="w-5 h-5 hover:text-danger stroke-current"
              class="ml-2"
              @click.stop="
                deletedId = tr.id;
                deletePopupActive = true;
              "
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <!-- Add/Edit Modal -->
    <vs-popup
      class="holamundo"
      title="Mutfak Ekle/Düzenle"
      :active.sync="popupActive"
      @close="closePopup"
    >
      <div class="con-form">
        <vs-input
          v-model="currentKitchen.name"
          label="Mutfak Adı"
          class="mt-5 w-full"
        />
        <vs-input
          v-model="currentKitchen.printerName"
          label="Mutfak Yazıcı Adı"
          class="mt-5 w-full"
        />
        <vs-button
          @click="saveKitchen"
          color="primary"
          type="filled"
          style="margin-top: 20px"
          >Kaydet</vs-button
        >
      </div>
    </vs-popup>
  </div>
</template>

<script>
import {
  getAllKitchen,
  updateKitchen,
  addKitchen,
  deleteKitchen,
} from "@/api/Kitchen";
import { getRoleList } from "@/api/Role.js";
export default {
  data() {
    return {
      roles: [],
      kitchens: [],
      popupActive: false,
      deletedId: null,
      deletePopupActive: false,
      currentKitchen: {
        id: null,
        name: "",
        printerName: "",
      },
    };
  },
  created: async function () {
    await this.loadKitchens();
    await this.loadRoles();
  },
  mounted: async function () {
    await this.loadRoles();
  },
  methods: {
    async loadRoles() {
      try {
        console.log(this.roles);

        const response = await getRoleList();
        this.roles = response.data;
        console.log(this.roles);
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Roller yüklenirken bir hata oluştu!",
        });
      }
    },
    async loadKitchens() {
      try {
        const response = await getAllKitchen();
        this.kitchens = response.data;
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Mutfaklar yüklenirken bir hata oluştu!",
        });
      }
    },
    openAddModal() {
      this.currentKitchen = { id: null, name: "" };
      this.popupActive = true;
    },
    editKitchen(kitchen) {
      this.currentKitchen = {
        ...kitchen,
      };
      this.popupActive = true;
    },
    async saveKitchen() {
      const kitchenData = {
        ...this.currentKitchen,
      };
      try {
        if (this.currentKitchen.id) {
          await updateKitchen(kitchenData);
        } else {
          await addKitchen(kitchenData);
        }
        await this.loadKitchens();
        this.popupActive = false;
        this.$vs.notify({
          color: "success",
          title: "Başarılı!",
          text: "Mutfak başarıyla kaydedildi!",
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Mutfak kaydedilirken bir hata oluştu!",
        });
      }
    },
    async deleteKitchen(id) {
      try {
        await deleteKitchen(id);
        await this.loadKitchens();
        this.deletePopupActive = false;
        this.$vs.notify({
          color: "success",
          title: "Başarılı!",
          text: "Mutfak başarıyla silindi!",
        });
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Mutfak silinirken bir hata oluştu!",
        });
      }
    },
  },
};
</script>
